export const SECRET = "diyasa49";
export const SESS_TIMEOUT = "7200";
export const IDLE_TIMEOUT = "0";
export const SUCCESS = "1";
